import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceGroupStreamSettings';
export const useSourceGroupStreamSettingsTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    data_title: 'Данные потока',
    autorestart_title: 'Параметры перезапуска',
    fields: {
      restart: 'Автоперезапуск',
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    data_title: 'Stream data',
    autorestart_title: 'Restart parameters',
    fields: {
      restart: 'Autorestart',
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    data_title: 'Datos del flujo',
    autorestart_title: 'Parámetros de reinicio',
    fields: {
      restart: 'Autorreinicio',
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    data_title: 'Dados do fluxo',
    autorestart_title: 'Parâmetros de reinício',
    fields: {
      restart: 'Autorreinício',
    },
  },
}) : {}) as Record<string, unknown>;
